import { useEffect, useState } from "react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function CategoriesPage() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", slug: "", description: "" });

  const load = () => api.get("/categories").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const submit = async () => {
    try { await api.post("/categories", form); toast.success("श्रेणी जोड़ी गयी"); setOpen(false); setForm({ name: "", slug: "", description: "" }); load(); }
    catch(err) { toast.error(formatError(err)); }
  };
  const del = async (id) => {
    if (!window.confirm("क्या हटाना है?")) return;
    try { await api.delete(`/categories/${id}`); load(); }
    catch(err) { toast.error(formatError(err)); }
  };

  return (
    <div data-testid="categories-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold">श्रेणी प्रबंधन</h1>
          <p className="text-sm text-slate-500 mt-1">कुल {items.length} श्रेणियाँ</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="bg-[#0F172A] hover:bg-[#1E3A8A]" data-testid="add-cat-btn"><Plus className="w-4 h-4 mr-1.5"/>नयी श्रेणी</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>नयी श्रेणी</DialogTitle><DialogDescription>पब्लिक साइट पर दिखाने के लिए नयी समाचार श्रेणी जोड़ें</DialogDescription></DialogHeader>
            <div className="space-y-3">
              <div><Label>नाम</Label><Input value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} data-testid="cat-name"/></div>
              <div><Label>Slug (URL)</Label><Input value={form.slug} onChange={(e) => setForm({...form, slug: e.target.value})} placeholder="auto-generate if empty"/></div>
              <div><Label>विवरण</Label><Input value={form.description} onChange={(e) => setForm({...form, description: e.target.value})}/></div>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => setOpen(false)}>रद्द</Button>
              <Button onClick={submit} className="bg-[#0F172A] hover:bg-[#1E3A8A]" data-testid="save-cat">जोड़ें</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg shadow-sm overflow-hidden">
        <Table>
          <TableHeader><TableRow><TableHead>नाम</TableHead><TableHead>Slug</TableHead><TableHead>विवरण</TableHead><TableHead className="text-right">कार्य</TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map((c) => (
              <TableRow key={c.id}>
                <TableCell className="font-medium">{c.name}</TableCell>
                <TableCell className="font-mono text-xs">{c.slug}</TableCell>
                <TableCell className="text-slate-600">{c.description}</TableCell>
                <TableCell className="text-right"><Button variant="ghost" size="sm" onClick={() => del(c.id)}><Trash2 className="w-4 h-4 text-red-500"/></Button></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
